<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <b-modal
        size="xl"
        id="modal-hoja-bienvenida"
        title="Hoja Bienvenida"
        ok-only
      >
        <div class="text-center">
          <b-button style="background-color: #FFFFFF; border: none" @click="descargarHojaBienvenida(idCita)"
            ></b-button
          >
        </div>
        <div id="imprimirHojaBienvenida" class="text-justify">
          <!-- -------------------------------- -->
          <div class="row">
            <div class="col-md-12">
              <b-img
                align="right"
                alt="logoDentaliaColo"
                src="../../logoColor.png"
                width="350"
              ></b-img>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <br />
              <h2 style="color: #053672;">
                <!-- 1 INFANTIL - 2 ADULTO -->
                <b v-if="idTipoDenticion == 2"
                  >Estimado (a), {{ nombrePaciente }}</b
                >
                <b v-else>Estimado (a), {{ nombreTutor }}</b>
              </h2>
              <h3 style="color: #053672">
                <b>Bienvenido (a) a dentalia, </b>
              </h3>
            </div>
          </div>

          <div class="row" align="justify">
            <div class="col-md-12" align="justify" style="color: #0e6ba9">
              <p>
                Nuestro compromiso es que vivas la mejor experiencia dental:
                Experiencia dentalia. <br /><br />
                Contamos con tecnología de punta y los mejores odontólogos y
                especialistas de México, presente en cada uno de los pasos que
                conforman la experiencia dentalia. <br /><br />
                La experiencia dentalia, cuenta con un centro de diagnóstico
                integral, conformado por los mejores odontólogos para cada una
                de las especialidades de la salud dental, los cuales
                diagnostican las herramientas digitales que se toman en nuestras
                clínicas a todos nuestros pacientes, dichas herramientas se
                complementan con el diagnóstico clínico que realiza nuestro
                Odontólogo General para lograr un diagnóstico 360º SIN COSTO.
              </p>

              <p v-if="idTipoDenticion == 2">
                Como consecuencia del diagnóstico 360º, desarrollaremos un plan
                de tratamiento integral para ti, de acuerdo con tus prioridades
                y estado de tu salud dental.
              </p>
              <p v-else>
                Como consecuencia del diagnóstico 360º, desarrollaremos un plan
                de tratamiento integral para tu pequeño (a), de acuerdo con sus
                prioridades y estado de su salud dental.
              </p>

              <p v-if="idTipoDenticion == 2">
                Nuestro Embajador de Experiencia dentalia, te presentará, de
                manera sencilla y transparente los tratamientos que requieres,
                diseñando una ruta clínica que da preferencia a la razón por la
                cual nos visitas:
                <b>{{ tagMotivoCita }}</b> y los tratamientos médicos
                indispensables, con el objeto de alcanzar tu salud dental
                óptima.
              </p>
              <p v-else>
                Nuestro Embajador de Experiencia dentalia, te presentará, de
                manera sencilla y transparente los tratamientos que tu hijo (a)
                requiere, diseñando una ruta clínica que da preferencia a la
                razón por la cual nos visitan:
                <b>{{ tagMotivoCita }}</b> y los tratamientos médicos
                indispensables, con el objeto de alcanzar su salud dental
                óptima.
              </p>

              <p>
                Podrás atender cualquier especialidad de la salud dental, en
                todas nuestras clínicas acompañado de los mejores odontólogos y
                especialistas de México.
              </p>

              <p v-if="idTipoDenticion == 2">
                Si cuentas con un plan dental en dentalia, recuerda que
                disfrutarás de beneficios adicionales.
              </p>
              <p v-else>
                Si <b>{{ nombrePaciente }}</b> cuenta con un plan dental en dentalia,
                recuerda que disfrutará de beneficios adicionales.
              </p>
              <p>
                Somos la cadena de clínicas dental, líder del país y nuestra
                razón de ser es mejorar la salud dental de México y el mundo;
                día con día trabajamos para conseguirlo.
              </p>

              <p v-if="idTipoDenticion == 2">
                En nombre de la familia dentalia, gracias por confiar en
                nosotros una de las cosas más valiosas: ¡tu salud dental!
              </p>
              <p v-else>
                En nombre de la familia dentalia, gracias por confiar en
                nosotros una de las cosas más valiosas: ¡tu salud dental de tu
                hijo (a)!
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <h2 style="color: #053672">
                <b>Atentamente, <br />La familia dentalia.</b>
                <br />
              </h2>
            </div>
            <div class="col-md-6"> 
              <b-img
                align="right"
                alt="logoCepillo"
                src="../../logoCepillo.png"
                width="350"
              ></b-img>
            </div>
          </div>

          <div
            class="row"
            style="
              background-color: #053672 !important;
              color: white;
              width: 100%;
              display: flex;
              flex-direction: row;
              padding: 10px;
              color-adjust: exact;
              -webkit-print-color-adjust: exact;
            "
          >
            <div class="col-md-4">
              <h5 align="left">
                <b
                  >hola@dentalia.com
                  <br />
                  800 003 3682
                </b>
              </h5>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-4" align="right">
              <b-form inline>
                <b-img
                  align="right"
                  alt="logoInstagram"
                  src="../../instagram.png"
                  width="35"
                ></b-img>
                <b-img
                  align="right"
                  alt="logoFacebook"
                  src="../../facebook.png"
                  width="35"
                ></b-img>
                <p align="right">www.dentalia.com</p>
              </b-form>
            </div>
          </div>
          <!-- -------------------------------- -->
        </div>
        <div class="text-center">
          <div class="row">
            <div class="col-md-12"><br /><br /><br /><br /></div>
          </div>
        </div>
        <div class="text-center">
          <b-button variant="success" @click="descargarHojaBienvenida(idCita)"
            >imprimir</b-button
          >
        </div>
        <br />
        <br />
        <br />
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "HojaBienvenida",
  components: {},
  props: {
    nombrePaciente: String,
    tagMotivoCita: String,
    idCita: Number,
    idTipoDenticion: Number, //1 INFANTIL - 2 ADULTO
    nombreTutor: String,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  computed: {},
  methods: {
    descargarHojaBienvenida(idCita) {
      this.$htmlToPaper("imprimirHojaBienvenida");

      this.$http
        .put(
          this.$api +
            "cita/registrar/fechaImpresionHojaBienvenida?idCita=" +
            idCita
        )
        .then(() => {
          // if (response.status === 200) {
          //   this.$swal.fire({
          //     icon: "success",
          //     title: "Aviso",
          //     text: "" +response.data.message,
          //   });
          // }
        })
        .catch((error) => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Ocurrio un error al realizar el registro de la impresion de la hoja de vienvenida del paciente",
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>